import dayjs from "dayjs";
import { useFormContext } from "react-hook-form";

import UserSelect from "../_Selects/UserSelect/UserSelect";

const Signature = ({ uuid, unitType, ...cell }: any) => {
  const { setValue } = useFormContext();
  const onChange = () => {
    const date = dayjs();
    const dateWrapper = document.getElementById("sig-date");
    const timeWrapper = document.getElementById("sig-time");

    if (dateWrapper) {
      const input = dateWrapper.querySelector(
        "input[type='hidden']",
      ) as HTMLInputElement;
      if (input?.name) {
        setValue(input.name, date.toDate());
      }
    }

    if (timeWrapper) {
      const input = timeWrapper.querySelector(
        "input[type='time']",
      ) as HTMLInputElement;
      if (input?.name) {
        setValue(input.name, dayjs(date).format("HH:mm"));
      }
    }
  };

  return (
    <UserSelect
      {...cell}
      id={uuid}
      cellCase={unitType}
      additionalOnChange={onChange}
      domId="medSig"
    />
  );
};

export default Signature;
